import PlantillaScreen3 from "../../helpers/PlantillaScreen3";

export const RealizarConteoHeaderModal = ({ open, onClose, info }) => {
    if (!open) return null;

    const estatusTexto = {
        N: "No Iniciado", P: "En Proceso", V: "Vencido",
        F: "Finalizado",  C: "Cancelado",  A: "Ajustado",
        I: "Por Iniciar", S: "Cargado",     R: "Segundo Conteo"
    };

    const estatusColor = {
        N: { bg: "#eef0ec", color: "#4f5a4b", border: "#d5d9d0" },
        P: { bg: "#eaf3de", color: "#27500a", border: "#97c459" },
        R: { bg: "#fff8e1", color: "#7c4a00", border: "#fbbf24" },
        F: { bg: "#e8f0fa", color: "#0c447c", border: "#85b7eb" },
        V: { bg: "#fcebeb", color: "#791f1f", border: "#f09595" },
        C: { bg: "#faeeda", color: "#633806", border: "#ef9f27" },
        I: { bg: "#f3effe", color: "#4c1d95", border: "#c4b5fd" },
        S: { bg: "#e0f7fa", color: "#065f70", border: "#67d4e8" },
        A: { bg: "#eaf3de", color: "#27500a", border: "#97c459" },
    };

    const cfg = estatusColor[info?.estatus] ?? estatusColor["N"];

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) onClose?.();
    };

    return (
        <div className="ram-backdrop" onClick={handleBackdropClick}>
            <PlantillaScreen3
                titulo="Resumen de Auditoría"
                className="ram-modal chm-modal"
                numero={2}
            >
                <button className="ram-close" onClick={onClose} type="button">X</button>

                <div className="ram-body chm-body">

                    <div className="chm-estatus-wrap">
                        <span
                            className="chm-estatus-badge"
                            style={{ background: cfg.bg, color: cfg.color, borderColor: cfg.border }}
                        >
                            <span className="chm-estatus-badge__dot" style={{ background: cfg.color }} />
                            {estatusTexto[info?.estatus]}
                        </span>
                    </div>

                    <div className="chm-grid">
                        
                        <div className="chm-block">
                            <span className="chm-sucursal">{info?.sucursal}</span>
                            <div className="chm-row">
                                <span className="chm-label">Folio</span>
                                <span className="chm-value chm-value--mono">{info?.folio}</span>
                            </div>
                            <div className="chm-row">
                                <span className="chm-label">Tipo inventario</span>
                                <span className="chm-value">{info?.tipo_inventario}</span>
                            </div>
                            <div className="chm-row">
                                <span className="chm-label">Últ. actualización</span>
                                <span className="chm-value">{info?.ult_actualizacion}</span>
                            </div>
                        </div>

                        <div className="chm-divider" />

                        <div className="chm-block">
                            <div className="chm-row">
                                <span className="chm-label">Responsable</span>
                                <span className="chm-value chm-value--link">{info?.responsable_alm}</span>
                            </div>
                            <div className="chm-row">
                                <span className="chm-label">Auditor responsable</span>
                                <span className="chm-value chm-value--link">{info?.auditor_ppal}</span>
                            </div>
                            <div className="chm-row">
                                <span className="chm-label">Periodo</span>
                                <span className="chm-value">{info?.periodo}</span>
                            </div>
                        </div>
                    </div>
                </div>

            </PlantillaScreen3>
        </div>
    );
};